import { render, staticRenderFns } from "./ModalDiscountLimit.vue?vue&type=template&id=384f86e3&"
import script from "./ModalDiscountLimit.vue?vue&type=script&lang=js&"
export * from "./ModalDiscountLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports